import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useGrantReferralCoins from '../../hooks/update-hooks/grant-referral-coins/grant-referral-coins';

const DEFAULT_AMOUNT = 250;

export default function GrantReferralCoins({ userId }) {
    const [open, setOpen] = useState(false);
    const [amount, setAmount] = useState(DEFAULT_AMOUNT);
    const [notes, setNotes] = useState('');

    const { mutate, isLoading } = useGrantReferralCoins(userId);

    const close = () => {
        setOpen(false);
        setAmount(DEFAULT_AMOUNT);
        setNotes('');
    };

    const handleSubmit = () => {
        const parsedAmount = parseFloat(amount);
        if (isNaN(parsedAmount) || parsedAmount <= 0) {
            return;
        }
        mutate(
            { amount: parsedAmount, notes },
            { onSuccess: (res) => { if (res?.data?.success !== false) close(); } }
        );
    };

    return (
        <div className="mt-6">
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="rounded-md bg-[#168c7c] px-4 py-2 font-sans font-semibold text-white-50 hover:bg-[#12796b]"
            >
                Grant Referral Coins
            </button>

            {open && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                    <div className="w-[420px] rounded-lg bg-white-50 p-6 shadow-xl">
                        <h3 className="mb-4 font-sans text-lg font-bold text-[#168c7c]">Grant Referral Coins</h3>

                        <label className="mb-1 block font-sans text-sm font-semibold text-gray-700">Amount</label>
                        <input
                            type="number"
                            min="1"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            className="mb-4 w-full rounded-md border border-gray-300 px-3 py-2 font-sans focus:border-[#168c7c] focus:outline-none"
                        />

                        <label className="mb-1 block font-sans text-sm font-semibold text-gray-700">Notes (optional)</label>
                        <textarea
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            rows={3}
                            placeholder="Reason for granting coins"
                            className="mb-4 w-full rounded-md border border-gray-300 px-3 py-2 font-sans focus:border-[#168c7c] focus:outline-none"
                        />

                        <div className="flex justify-end gap-3">
                            <button
                                type="button"
                                onClick={close}
                                disabled={isLoading}
                                className="rounded-md border border-gray-300 px-4 py-2 font-sans font-semibold text-gray-700 hover:bg-gray-100 disabled:opacity-50"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={handleSubmit}
                                disabled={isLoading}
                                className="rounded-md bg-[#168c7c] px-4 py-2 font-sans font-semibold text-white-50 hover:bg-[#12796b] disabled:opacity-50"
                            >
                                {isLoading ? 'Granting...' : 'Grant'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

GrantReferralCoins.propTypes = {
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
